var _style, _g, _rect, _rect2, _rect3, _rect4, _g2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuropean(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 942.96 269.29",
    style: {
      enableBackground: "new 0 0 942.96 269.29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Arched_x0020_Green{fill:url(#SVGID_1_);stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:1;}\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;}\n\t.st2{display:none;fill:none;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#034EA2;}\n\t.st5{fill:#FFF200;}\n\t.st6{font-family:'MyriadPro-Regular';}\n\t.st7{font-size:50px;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 269.29,
    x2: 0.7071,
    y2: 268.5829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20AC4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    style: {
      stopColor: "#19361A"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.18,219.68h-56.03v-85.04h56.03v10.05h-44.72V168h44.72v10.05h-44.72v31.58h44.72V219.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448.66,167.6h-0.57c-1.6-0.38-3.15-0.66-4.65-0.83c-1.5-0.17-3.28-0.26-5.34-0.26c-3.31,0-6.51,0.73-9.59,2.2 c-3.08,1.47-6.05,3.36-8.91,5.68v45.29h-10.74v-63.79h10.74v9.42c4.26-3.43,8.02-5.85,11.28-7.28c3.25-1.43,6.58-2.14,9.97-2.14 c1.87,0,3.22,0.05,4.05,0.14c0.84,0.09,2.09,0.28,3.77,0.54V167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M506.41,219.68h-10.68v-6.79c-0.95,0.65-2.24,1.55-3.85,2.71c-1.62,1.16-3.19,2.09-4.71,2.77 c-1.79,0.88-3.85,1.61-6.17,2.2c-2.32,0.59-5.05,0.89-8.17,0.89c-5.75,0-10.62-1.9-14.62-5.71c-4-3.81-6-8.66-6-14.56 c0-4.84,1.04-8.75,3.11-11.74c2.07-2.99,5.03-5.34,8.88-7.05c3.88-1.71,8.55-2.88,13.99-3.48c5.44-0.61,11.29-1.07,17.53-1.37 v-1.66c0-2.44-0.43-4.46-1.28-6.05c-0.86-1.6-2.08-2.86-3.68-3.77c-1.52-0.88-3.35-1.46-5.48-1.77c-2.13-0.3-4.36-0.46-6.68-0.46 c-2.82,0-5.96,0.37-9.42,1.11c-3.47,0.74-7.04,1.82-10.74,3.23h-0.57v-10.91c2.09-0.57,5.12-1.2,9.08-1.88 c3.96-0.69,7.86-1.03,11.71-1.03c4.49,0,8.4,0.37,11.74,1.11c3.33,0.74,6.22,2.01,8.65,3.8c2.4,1.75,4.23,4.02,5.48,6.79 c1.26,2.78,1.88,6.23,1.88,10.34V219.68z M495.73,203.98v-17.76c-3.27,0.19-7.13,0.48-11.56,0.86c-4.44,0.38-7.95,0.93-10.54,1.66 c-3.08,0.88-5.58,2.24-7.48,4.08c-1.9,1.85-2.86,4.39-2.86,7.62c0,3.65,1.1,6.41,3.31,8.25c2.21,1.85,5.58,2.77,10.11,2.77 c3.77,0,7.21-0.73,10.34-2.2C490.17,207.8,493.07,206.04,495.73,203.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M568.59,201.29c0,5.83-2.41,10.61-7.22,14.34c-4.82,3.73-11.39,5.6-19.73,5.6c-4.72,0-9.05-0.56-12.99-1.69 c-3.94-1.12-7.24-2.35-9.91-3.68v-12.05h0.57c3.39,2.55,7.16,4.58,11.31,6.08c4.15,1.51,8.13,2.26,11.94,2.26 c4.72,0,8.41-0.76,11.08-2.28c2.66-1.52,4-3.92,4-7.2c0-2.51-0.72-4.42-2.17-5.71c-1.45-1.29-4.23-2.4-8.34-3.31 c-1.52-0.34-3.51-0.74-5.97-1.2c-2.46-0.46-4.69-0.95-6.71-1.48c-5.6-1.49-9.57-3.66-11.91-6.54s-3.51-6.41-3.51-10.6 c0-2.63,0.54-5.1,1.63-7.42c1.09-2.32,2.73-4.4,4.94-6.22c2.13-1.79,4.84-3.21,8.14-4.26c3.29-1.05,6.98-1.57,11.05-1.57 c3.81,0,7.66,0.47,11.57,1.4c3.9,0.93,7.15,2.07,9.74,3.4v11.48h-0.57c-2.74-2.02-6.07-3.72-10-5.11 c-3.92-1.39-7.77-2.09-11.54-2.09c-3.92,0-7.23,0.75-9.94,2.26c-2.7,1.51-4.06,3.74-4.06,6.71c0,2.63,0.82,4.61,2.46,5.94 c1.6,1.33,4.19,2.42,7.77,3.26c1.98,0.46,4.2,0.91,6.65,1.37c2.46,0.46,4.5,0.88,6.14,1.26c4.99,1.14,8.83,3.1,11.54,5.88 C567.24,192.92,568.59,196.65,568.59,201.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M673.08,219.68h-10.74v-36.32c0-2.74-0.12-5.39-0.37-7.94c-0.25-2.55-0.77-4.59-1.57-6.11 c-0.88-1.64-2.13-2.87-3.77-3.71c-1.64-0.84-4-1.26-7.08-1.26c-3.01,0-6.02,0.75-9.02,2.26c-3.01,1.51-6.02,3.42-9.02,5.74 c0.11,0.88,0.21,1.89,0.29,3.05c0.08,1.16,0.11,2.31,0.11,3.46v40.83h-10.74v-36.32c0-2.82-0.12-5.49-0.37-8.03 c-0.25-2.53-0.77-4.56-1.57-6.08c-0.88-1.64-2.13-2.87-3.77-3.68c-1.64-0.82-4-1.23-7.08-1.23c-2.93,0-5.87,0.72-8.82,2.17 c-2.95,1.45-5.89,3.29-8.82,5.54v47.63h-10.74v-63.79h10.74v7.08c3.35-2.78,6.69-4.95,10.02-6.51c3.33-1.56,6.88-2.34,10.65-2.34 c4.34,0,8.02,0.91,11.05,2.74c3.03,1.83,5.28,4.36,6.77,7.6c4.34-3.66,8.3-6.29,11.88-7.91c3.58-1.62,7.41-2.43,11.48-2.43 c7.01,0,12.17,2.12,15.51,6.37c3.33,4.25,5,10.18,5,17.79V219.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M740.71,219.68h-10.74v-7.08c-3.62,2.86-7.08,5.05-10.39,6.57c-3.31,1.52-6.97,2.29-10.97,2.29 c-6.7,0-11.92-2.05-15.65-6.14c-3.73-4.09-5.6-10.1-5.6-18.02v-41.41h10.74v36.32c0,3.24,0.15,6.01,0.46,8.31 c0.3,2.3,0.95,4.27,1.94,5.91c1.03,1.68,2.36,2.89,4,3.66c1.64,0.76,4.02,1.14,7.14,1.14c2.78,0,5.82-0.72,9.11-2.17 c3.29-1.45,6.37-3.29,9.22-5.54v-47.63h10.74V219.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M803.41,201.29c0,5.83-2.41,10.61-7.22,14.34c-4.82,3.73-11.39,5.6-19.73,5.6c-4.72,0-9.05-0.56-12.99-1.69 c-3.94-1.12-7.24-2.35-9.91-3.68v-12.05h0.57c3.39,2.55,7.16,4.58,11.31,6.08c4.15,1.51,8.13,2.26,11.94,2.26 c4.72,0,8.41-0.76,11.08-2.28c2.67-1.52,4-3.92,4-7.2c0-2.51-0.72-4.42-2.17-5.71c-1.45-1.29-4.23-2.4-8.34-3.31 c-1.52-0.34-3.51-0.74-5.97-1.2c-2.46-0.46-4.69-0.95-6.71-1.48c-5.6-1.49-9.57-3.66-11.91-6.54s-3.51-6.41-3.51-10.6 c0-2.63,0.54-5.1,1.63-7.42c1.09-2.32,2.73-4.4,4.94-6.22c2.13-1.79,4.84-3.21,8.14-4.26c3.29-1.05,6.98-1.57,11.05-1.57 c3.81,0,7.66,0.47,11.57,1.4c3.9,0.93,7.15,2.07,9.74,3.4v11.48h-0.57c-2.74-2.02-6.07-3.72-10-5.11 c-3.92-1.39-7.77-2.09-11.54-2.09c-3.92,0-7.23,0.75-9.94,2.26c-2.7,1.51-4.06,3.74-4.06,6.71c0,2.63,0.82,4.61,2.46,5.94 c1.6,1.33,4.19,2.42,7.77,3.26c1.98,0.46,4.2,0.91,6.65,1.37c2.46,0.46,4.5,0.88,6.14,1.26c4.99,1.14,8.83,3.1,11.54,5.88 C802.06,192.92,803.41,196.65,803.41,201.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M893.35,187.02h-31.13v31.13h-9.48v-31.13h-31.13v-9.14h31.13v-31.12h9.48v31.12h31.13V187.02z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 219.68,
    className: "st2",
    width: 49.61,
    height: 49.61
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 893.35,
    y: 219.68,
    className: "st2",
    width: 49.61,
    height: 49.61
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 893.35,
    y: 0,
    className: "st2",
    width: 49.61,
    height: 49.61
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st2",
    width: 49.61,
    height: 49.61
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.22,
    y: 46.22,
    className: "st3",
    width: 261.9,
    height: 176.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.61,
    y: 49.6,
    className: "st4",
    width: 255.12,
    height: 170.08
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "177.18,68.5 179.28,75.07 186.15,75.04 180.57,79.06 182.72,85.59 177.18,81.52 171.62,85.6  173.78,79.06 168.18,75.04 175.07,75.07  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "148.83,76.1 150.93,82.66 157.81,82.63 152.22,86.65 154.38,93.19 148.83,89.12 143.27,93.19  145.43,86.65 139.83,82.63 146.72,82.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "128.08,96.85 130.18,103.41 137.06,103.38 131.47,107.4 133.63,113.94 128.08,109.87 122.52,113.94  124.68,107.41 119.08,103.38 125.97,103.41  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "120.49,125.2 122.59,131.76 129.46,131.73 123.88,135.75 126.03,142.29 120.49,138.21  114.93,142.29 117.09,135.75 111.49,131.73 118.38,131.76  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "128.08,153.54 130.18,160.1 137.06,160.08 131.47,164.1 133.63,170.63 128.08,166.56 122.52,170.64  124.68,164.1 119.08,160.08 125.97,160.11  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "148.83,174.29 150.93,180.86 157.81,180.83 152.22,184.85 154.38,191.38 148.83,187.31  143.27,191.39 145.43,184.85 139.84,180.83 146.72,180.86  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "177.18,181.88 179.28,188.45 186.16,188.42 180.57,192.44 182.73,198.98 177.18,194.9  171.62,198.98 173.78,192.44 168.19,188.42 175.07,188.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "205.53,174.29 207.63,180.85 214.5,180.82 208.91,184.84 211.07,191.38 205.53,187.31  199.96,191.38 202.12,184.84 196.53,180.82 203.42,180.85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "226.28,153.54 228.38,160.1 235.25,160.07 229.66,164.09 231.82,170.63 226.28,166.56  220.71,170.63 222.88,164.09 217.28,160.07 224.17,160.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "233.87,125.19 235.97,131.75 242.85,131.73 237.26,135.75 239.42,142.28 233.87,138.21  228.31,142.29 230.47,135.75 224.87,131.73 231.76,131.75  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "226.28,96.85 228.38,103.41 235.25,103.38 229.66,107.4 231.82,113.94 226.27,109.87 220.71,113.94  222.88,107.4 217.28,103.38 224.17,103.41  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "205.53,76.1 207.62,82.66 214.5,82.63 208.91,86.65 211.07,93.19 205.52,89.12 199.96,93.19  202.12,86.65 196.53,82.63 203.41,82.66  "
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 331.439 93.4706)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st6 st7"
  }, "Co-founded by"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60,
    className: "st6 st7"
  }, "the Erasmus + Programme"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 120,
    className: "st6 st7"
  }, "of the European Union"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropean);
export default __webpack_public_path__ + "static/media/european.d8dbd0a23f85359bf8221ed213627118.svg";
export { ForwardRef as ReactComponent };